export const environment = {
  name: 'test',
  appName: 'SpeakNode',
  appLandingUrl: 'https://speaknode.com',
  widgetUrl: 'https://test-widget.speaknode.com',
  production: false,
  generatedApiUrl: 'https://test.api.speaknode.com',
  appUrl: 'https://test.app.speaknode.com',
  livekitUrl: 'https://test-livekit.speaknode.com',
  livekitSipGatewayUrl: 'test-livekit-sip.speaknode.com',
  hashbrownProxyUrl: 'https://test.llm-proxy.speaknode.com',
  assistantModel: 'openai/gpt-4o-mini',
  // Hard on/off switch for the in-app assistant chat. When false the
  // chat doesn't render at all, regardless of `assistantRoles`.
  // SKN-411: включено — тест и есть то место, где агента гоняют.
  // В проде уже true. Перебивается ASSISTANT_ENABLED в контейнере.
  assistantEnabled: true,
  // Client roles allowed to see the agent assistant chat.
  // Empty → chat is shown to all users.
  assistantRoles: [] as string[],
  keycloak: {
    url: 'https://test.identity.speaknode.com',
    realm: 'speaknode',
    clientId: 'speaknode-client'
  },
  test: {
    accessToken: '!!!TEST_ME_PLEASE_222!!!'
  },
  docsUrl: 'https://test.docs.speaknode.com',
  billing: {
    url: 'https://test.app-billing.speaknode.com',
    defaultPlanCode: 'free'
  },
  posthog: {
    key: 'phc_S7iiio1I9I29idY3uGSCWnvXOpDarIEuXqwire21GxA',
    host: 'https://eu.i.posthog.com'
  }
};
